import defs from '../_core/defs.js';
import triggerOne from '../trigger/_triggerone.js';
import domEventReg from '../on/_domeventregexp.js';
import forEach from '../_helpers/foreach.js';
import forOwn from '../_helpers/forown.js';
import removeDomListener from './_removedomlistener.js';
import isSameCallback from '../_helpers/issamecallback.js';
import { dropOwner, hasOwner } from '../on/_owners.js';
import cancelIfGone from './_cancelifgone.js';
// removes simple event listener from an object
export default function removeListener(object, name, callback, context, info) {
  var _info$owner;
  // every caller passes an object that has listeners
  var def = defs.get(object);
  var allEvents = def.events;
  var events = name === undefined ? undefined : allEvents[name];
  var retain = [];
  var domEventExecResult = name === undefined ? null : domEventReg.exec(name);
  // a delegation removes only its own listener, the one it added with this callback and context
  var owner = (_info$owner = info == null ? void 0 : info.owner) != null ? _info$owner : null;
  if (domEventExecResult) {
    var eventName = domEventExecResult[1],
      _domEventExecResult$ = domEventExecResult[2],
      key = _domEventExecResult$ === void 0 ? 'sandbox' : _domEventExecResult$,
      selector = domEventExecResult[3];
    removeDomListener(object, def, key, eventName, selector, callback, context, owner);
    return true;
  }
  // if all events need to be removed
  if (typeof name === 'undefined') {
    forOwn(allEvents, function (allEventsItem, allEventsName) {
      forEach(allEventsItem, function (event) {
        var removeEventData = {
          name: allEventsName,
          callback: event.callback,
          context: event.context
        };
        triggerOne(object, "removeevent:" + allEventsName, removeEventData);
        triggerOne(object, 'removeevent', removeEventData);
      });
    });
    // restore default value of "events"
    def.events = Object.create(null);
  } else if (events) {
    var removed = [];
    var matches = function matches(event) {
      return owner ? event.callback === callback && event.context === context : (!callback || isSameCallback(callback, event.callback)) && (!context || context === event.context);
    };
    // if events with given name are found
    forEach(events, function (event) {
      if (!matches(event) || !hasOwner(event, owner) || !dropOwner(event, owner)) {
        // kept: another listener, or one somebody else still keeps
        retain.push(event);
      } else {
        removed.push({
          name: name,
          callback: event.callback,
          context: event.context
        });
      }
    });
    if (retain.length) {
      allEvents[name] = retain;
    } else {
      delete allEvents[name];
    }
    // a delegation that goes from one object keeps a call pending from another one
    if (!owner) {
      forEach(removed, function (_ref) {
        var removedCallback = _ref.callback;
        return cancelIfGone(allEvents, removedCallback);
      });
    }
    // after the list changes: a handler that calls off() or on() for the same name sees the listener gone
    if (name[0] !== '_') {
      forEach(removed, function (removeEventData) {
        triggerOne(object, "removeevent:" + name, removeEventData);
        triggerOne(object, 'removeevent', removeEventData);
      });
    }
  }
  return false;
}